import React from "react";
import { useFormikContext } from "formik";
import { dateFormat } from "../../utils/dateHelpers";
import Icon from "../Icon";
import { classNames } from "../../utils/helpers";
import { useFindItem } from "../../hooks/useFindItem";
import { FormatInt } from "../../utils/FormatData";
const TotalAudience = () => {
  const { values } = useFormikContext();
  const { listDatabases, uiddatabase } = values;
  const audiencie =
    useFindItem(listDatabases, "uiddatabase", uiddatabase) || {};

  return (
    <div className="p-6 bg-white rounded-2xl border space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-xl font-bold text-gray-600">Audiencia Total</div>
        <span
          className={classNames(
            "text-[12px] font-semibold flex justify-center gap-2 items-center text-gray-600 rounded-lg !px-4 !py-1.5",
            {
              "bg-green-100 text-green-800": audiencie?.active,
              "bg-red-100 text-red-800": !audiencie?.active,
            }
          )}
        >
          <Icon
            icon="storage"
            className={classNames({
              "text-green-800": audiencie?.active,
              "text-red-800": !audiencie?.active,
            })}
          />
          {audiencie?.active ? "Activo" : "Inactivo"}
        </span>
      </div>
      {Object.keys(audiencie).length > 0 ? (
        <>
          <div className="flex justify-between mb-2">
            <div className="flex items-center gap-2">
              <Icon icon="group" size={40} />
              <span className="font-bold text-3xl text-gray-600">
                {FormatInt(audiencie?.records ?? 0)}
              </span>{" "}
              <span className="text-gray-600 font-semibold">Registros</span>
            </div>
          </div>

          <div className="flex justify-star items-center gap-2">
            <span className="font-semibold text-gray-600 text-sm">
              Última Actualización:
            </span>
            <span className="font-semibold text-gray-600 text-md">
              {dateFormat(audiencie?.lastupdate, "DD/MM/YYYY HH:mm") ?? "---"}
            </span>
          </div>
          <div className="flex justify-start items-center gap-2">
            <span className="font-semibold text-gray-600 text-sm">
              Carrier:
            </span>
            <span className="font-semibold text-gray-600 text-md">
              {audiencie?.carrier ?? "---"}
            </span>
          </div>
        </>
      ) : (
        <div className="font-semibold text-md text-gray-500">
          {" "}
          No ha seleccionado una base de datos
        </div>
      )}
    </div>
  );
};

export default TotalAudience;
